import React, { useState, useEffect } from 'react';
import Select from 'react-select-nested-group';
import * as R from 'ramda';
import moment from 'moment';
import toastr from "toastr";
import { Spinner } from '../common/Spinner';
import DateTime from 'react-datetime';
import { Modal, Button } from 'react-bootstrap';

import Things from "../../ducks/Things";
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";

const DeviceSettings = (props) => {
  const companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({
    outletName: "",
    assetCode: "",
    sysLat:"",
    sysLng:"",
    storeCode: "",
    storeName: "",
    area: "",
    region: "",
    outletCode: "",
    freezerCapacity: "",
  });

  const columns = [
    { name: 'Imei', selector: "imei", wrap: true },
    { name: 'Name', selector: "name", wrap: true },
    { name: 'Outlet Name', selector: "outletName", wrap: true },
    { name: 'Asset Code', selector: "assetCode", wrap: true },
    { name: 'System Latitude', selector: "sysLat", wrap: true },
    { name: 'System Longitude', selector: "sysLng", wrap: true },
    { name: 'Store Code', selector: "storeCode", wrap: true },
    { name: 'Store Name', selector: "storeName", wrap: true },
    { name: 'Area', selector: "area", wrap: true },
    { name: 'Region', selector: "region", wrap: true },
    { name: 'Outlet Code', selector: "outletCode", wrap: true },
    { name: 'Freezer Capacity', selector: "freezerCapacity", wrap: true },
  ];

  useEffect(() => {
    (async () => {
      await props.thingsActions.getGroupVehicles({ groupId: companyInfo.groupId });
    })();
  }, []);

  const handleRowSelected = (state) => {
    setSelectedRows(state.selectedRows);
  };

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleInputChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // API call or update logic here
    const imeis = selectedRows.map(r => r.imei);
    await props.thingsActions.updateThingsData({imeis, data: formValues})
    toastr.success("Fields updated successfully!");
    handleCloseModal();
  };

  return (
    <>
      <div className="p-3">
        {selectedRows.length > 0 && (
          <Button variant="primary" onClick={handleOpenModal} className="mb-2">
            Update Fields
          </Button>
        )}

        <DataTable
          title={'Device Settings'}
          columns={columns}
          data={props.things}
          selectableRows
          onSelectedRowsChange={handleRowSelected}
          selectableRowsHighlight
          fixedHeader
        />

        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Update Fields</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit}>
              {Object.keys(formValues).map((key) => (
                <div className="mb-3" key={key}>
                  <label className="form-label text-capitalize">{key.replace(/([A-Z])/g, ' $1')}</label>
                  <input
                    type="text"
                    name={key}
                    className="form-control"
                    value={formValues[key]}
                    onChange={handleInputChange}
                  />
                </div>
              ))}
              <Button variant="success" type="submit" className="mt-2 w-100">
                Save Changes
              </Button>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  things: state.things.groupVehicles,
});

const mapDispatchToProps = (dispatch) => ({
  thingsActions: bindActionCreators(Things.creators, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeviceSettings));
